import { observer } from "mobx-react-lite";
import * as React from "react";
import { useParams } from "react-router-dom";
import { SpecificationsAccessEditor } from "src/business/specification/SpecificationsAccessEditor";
import { onError } from "src/common/onError";
import { LoaderBox } from "src/components/LoaderBox";
import { PageLayout } from "src/components/PageLayout";

import {
  ClassifierAccessData,
  classifierAccessStore as pageStore,
} from "./classifierAccessStore";

export const ManagementClassifierAccess: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  return (
    <PageLayout title={pageStore.crumbs}>
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </PageLayout>
  );
});

const Inner: React.FC<{ data: ClassifierAccessData }> = observer(({ data }) => {
  const { classifier, editorStore } = data;
  return (
    <SpecificationsAccessEditor title={classifier.name} store={editorStore} />
  );
});
